import { defineStore } from 'pinia'

interface AuthState {
  accessToken: string | null
  refreshToken: string | null
  expiresAt: number | null
  shouldRemember: boolean | null
  oktaKey: string | null
}

const STORE_KEY = 'revio.credentials'

export const useAuthStore = defineStore('auth', {
  state: (): AuthState => {
    const defaultState: AuthState = {
      accessToken: null,
      refreshToken: null,
      expiresAt: null,
      shouldRemember: null,
      oktaKey: null
    }

    // Load from local storage
    const savedData = localStorage.getItem(STORE_KEY) || sessionStorage.getItem(STORE_KEY)
    if (savedData) {
      return { ...defaultState, ...JSON.parse(savedData) }
    }

    return defaultState
  },
  actions: {
    setTokens(accessToken: string, refreshToken: string, expiresAt: number) {
      this.accessToken = accessToken
      this.refreshToken = refreshToken
      this.expiresAt = expiresAt
      this.oktaKey = null

      // Save to local storage
      if (this.shouldRemember) {
        localStorage.setItem(STORE_KEY, JSON.stringify(this.$state))
      }
      sessionStorage.setItem(STORE_KEY, JSON.stringify(this.$state))
    },
    setRemember(shouldRemember: boolean) {
      this.shouldRemember = shouldRemember
    },
    setOktaKey(value: string | null) {
      this.oktaKey = value
      localStorage.setItem(STORE_KEY, JSON.stringify(this.$state))
    },
    clearTokens() {
      this.accessToken = null
      this.refreshToken = null
      this.expiresAt = null
      this.shouldRemember = true
      this.oktaKey = null

      // Clean local storage
      localStorage.removeItem(STORE_KEY)
      sessionStorage.removeItem(STORE_KEY)
    },
  },
})
